/* =========================================================================
   BOGO link offer — session detection.

   The offer is delivered by a share link (/discount/<CODE>?redirect=...).
   Shopify persists that code on the visitor's cart, including while the cart
   is still empty, so it survives until they add something.

   WHY THIS IS CLIENT-SIDE
   `cart.discount_codes` does NOT exist in Liquid — it is a field of the
   /cart.js AJAX response only. Verified on this store 2026-08-18: with the
   code applied and 2 items in the cart, /cart.js reported the code while
   Liquid rendered `null`. So the session check cannot happen server-side, and
   this file is what closes that gap.

   Liquid renders the label markup (hidden) for products in the offer; this
   adds `html.bogo-link-active`, and base-custom.css reveals it. Same shape as
   `html.fg-gift-variant` for the free-gift tile label, and it lives on <html>
   so it survives cart-drawer and section re-renders.

   The result is cached in sessionStorage, so only the first page of a session
   pays for the /cart.js request and every later page reveals synchronously
   with no flicker.
   ========================================================================= */
(function () {
  var CLASS = 'bogo-link-active';
  var KEY = 'jiyu:bogo-link-active';

  var cfg = window.jiyuBogo || {};
  var prefix = (cfg.prefix || '').trim().toLowerCase();
  if (!prefix) return;

  function activate() {
    document.documentElement.classList.add(CLASS);
  }

  // Synchronous reveal on every page after the first — no request, no flicker.
  try {
    if (sessionStorage.getItem(KEY) === '1') {
      activate();
      return;
    }
  } catch (e) {
    // Private mode / storage disabled: fall through to the fetch each page.
  }

  function matches(codes) {
    if (!codes || !codes.length) return false;
    for (var i = 0; i < codes.length; i++) {
      var code = (codes[i] && codes[i].code ? codes[i].code : '').toLowerCase();
      if (code.indexOf(prefix) === 0) return true;
    }
    return false;
  }

  function check() {
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !matches(cart.discount_codes)) return;
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
        activate();
      })
      .catch(function () {
        // Never block or surface anything: no offer shown is the safe outcome.
      });
  }

  // Non-urgent: the label is below the fold on arrival, so stay off the
  // critical path and let paint finish first.
  if ('requestIdleCallback' in window) {
    requestIdleCallback(check, { timeout: 2000 });
  } else {
    setTimeout(check, 0);
  }
})();
